/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CoverageStatusDto
 */
export interface CoverageStatusDto {
    /**
     * Operating area ID
     * @type {number}
     * @memberof CoverageStatusDto
     */
    operatingAreaId: number;
    /**
     * Country code
     * @type {string}
     * @memberof CoverageStatusDto
     */
    countryCode: string;
    /**
     * Admin area 1 code (province/region)
     * @type {string}
     * @memberof CoverageStatusDto
     */
    adminArea1Code: string | null;
    /**
     * Admin area 2 code (city/district)
     * @type {string}
     * @memberof CoverageStatusDto
     */
    adminArea2Code: string | null;
    /**
     * Whether this area is covered by at least one warehouse
     * @type {boolean}
     * @memberof CoverageStatusDto
     */
    isCovered: boolean;
    /**
     * Names of warehouses covering this area
     * @type {Array<string>}
     * @memberof CoverageStatusDto
     */
    coveredByWarehouses: Array<string>;
}

/**
 * Check if a given object implements the CoverageStatusDto interface.
 */
export function instanceOfCoverageStatusDto(value: object): value is CoverageStatusDto {
    if (!('operatingAreaId' in value) || value['operatingAreaId'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('adminArea1Code' in value) || value['adminArea1Code'] === undefined) return false;
    if (!('adminArea2Code' in value) || value['adminArea2Code'] === undefined) return false;
    if (!('isCovered' in value) || value['isCovered'] === undefined) return false;
    if (!('coveredByWarehouses' in value) || value['coveredByWarehouses'] === undefined) return false;
    return true;
}

export function CoverageStatusDtoFromJSON(json: any): CoverageStatusDto {
    return CoverageStatusDtoFromJSONTyped(json, false);
}

export function CoverageStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CoverageStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'operatingAreaId': json['operatingAreaId'],
        'countryCode': json['countryCode'],
        'adminArea1Code': json['adminArea1Code'],
        'adminArea2Code': json['adminArea2Code'],
        'isCovered': json['isCovered'],
        'coveredByWarehouses': json['coveredByWarehouses'],
    };
}

export function CoverageStatusDtoToJSON(value?: CoverageStatusDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'operatingAreaId': value['operatingAreaId'],
        'countryCode': value['countryCode'],
        'adminArea1Code': value['adminArea1Code'],
        'adminArea2Code': value['adminArea2Code'],
        'isCovered': value['isCovered'],
        'coveredByWarehouses': value['coveredByWarehouses'],
    };
}

